import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { BreakpointProvider } from 'react-socks';
import Home from './components/Home';
import Header from './components/Header';
import Body from './components/Body';

import './App.css';

function App() {
  return (
    <BreakpointProvider>
        <div className="App">
          <Home />
          <Header />
          <Body />
        </div>
    </BreakpointProvider>
   
  );
}

export default App;
